import React, { useContext } from 'react';
import { Button, Grid } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';

import { AuthenticationContext } from '../contexts/AuthenticationContext';

import axios from '../../../sharedModules/utils/axios.utils';

const LoginPage: React.FC = () => {
  const isAuthenticated = useIsAuthenticated();
  const history = useHistory();

  const { setUser } = useContext(AuthenticationContext);

  const { instance } = useMsal();

  const handleMicrosoftLogin = async () => {
    try {
      const loginResponse = await instance.loginPopup({ scopes: ['User.Read'] });
      const account = loginResponse.account;
      const result = await axios.get<any, any>(`/sessions?microsoft_auth_id=${account.homeAccountId}`);
      setUser(result.data.user);

      // Redirect after user context is set
      const redirectUrl = sessionStorage.getItem('redirectAfterLogin');
      if (redirectUrl) {
        sessionStorage.removeItem('redirectAfterLogin');
        history.push(redirectUrl);
      } else {
        history.push('/home');
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div style={{ marginTop: 100, marginLeft: 20, marginRight: 20 }}>
      <Grid container justifyContent="center">
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <img
            style={{ height: 40 }}
            alt="logo"
            src="https://www.tudi.com/wp-content/themes/boxpress/assets/img/dist/branding/tudi-mechanical-logo@2x.png"
          />
        </Grid>
        <Grid item xs={12} md={6} style={{ display: 'flex', justifyContent: 'center', marginTop: 50 }}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleMicrosoftLogin}
            style={{ marginLeft: '10px', background: 'white' }}
          >
            <img src="https://cdn-icons-png.flaticon.com/512/732/732221.png" alt="Windows Icon" height="24px" />
            <span style={{ marginLeft: 7, color: '#333' }}>Microsoft Login</span>
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default LoginPage;
